import { Box, Paper, Stack, Typography } from '@mui/material';
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';
import React, { useEffect, useState } from 'react';
import GlobalSelectFieldWithoutFormikNew from '../../../../../components/mui/GlobalSelectFieldWithoutFormikNew';
import { WEEKS } from '../utils/Constains';
import { useDispatch } from 'react-redux';
import { getIndividualCards } from '../../../../../redux/features/poinTrackerSlice';

export default function HeadFilterCard() {
  const [week, setWeek] = useState({ id: 1, value: 'Week 1' });
  const dispatch = useDispatch();

  useEffect(() => {
    const cardThunkApi = dispatch(getIndividualCards({ week: week?.id }));
    return () => {
      cardThunkApi.abort();
    };
  }, [week, dispatch]);

  return (
    <Paper sx={{ p: 2 }} elevation={2}>
      <Stack justifyContent={'space-between'} direction={{ xs: 'column', md: 'row' }} gap={2}>
        <Stack direction={'row'} alignItems={'center'} gap={2}>
          <Box
            sx={{
              width: 50,
              height: 50,
              borderRadius: '50%',
              bgcolor: '#4F39F6',
              color: 'white',
              justifyContent: 'center',
              alignItems: 'center',
              display: { xs: 'none', sm: 'flex' },
            }}
          >
            <GroupOutlinedIcon
              sx={{
                width: 30,
                height: 30,
                color: 'inherit',
              }}
            />
          </Box>
          <Typography variant="h4">
            Individual Performance Breakdown{' '}
            <Box
              component={'span'}
              sx={{
                textTransform: 'capitalize',
              }}
              color={'#155DFC'}
            >
              ({`${week?.value}`})
            </Box>
          </Typography>
        </Stack>
        <GlobalSelectFieldWithoutFormikNew
          label={'Week'}
          data={WEEKS}
          setChange={setWeek}
          selectedDetails={week}
          keys={{
            itemId: 'id',
            itemValue: 'name',
          }}
        />
      </Stack>
    </Paper>
  );
}
